export default "__VITE_ASSET__DVXRis90__"